import { jsonToInputParams } from 'library/util/graph';
import DataQuery from 'library/util/query';
import { resolve } from 'library/helpers/path-resolver';

const markStep = async ({ step_id, user_uuid, markComplete }) => {
  let markStepFunction = removeCompletedStep;
  if (markComplete) markStepFunction = completeStep;
  const { data } = await markStepFunction({
    step_id: step_id,
    uuid: user_uuid,
  });
  return markStepParseQuery(data);
};

const removeCompletedStep = async ({ step_id, user_uuid }) =>
  await DataQuery(
    `mutation {
      step_completion:uncomplete_user_step(${jsonToInputParams({
        step_id: step_id,
        uuid: user_uuid,
      })}) {
        errors
        success
      }
    }`
  );

const completeStep = async ({ step_id, user_uuid }) =>
  await DataQuery(
    `mutation {
      step_completion:complete_user_step(${jsonToInputParams({
        step_id: step_id,
        uuid: user_uuid,
      })}) {
        errors
        success
      }
    }`
  );

const markStepParseQuery = (data) => {
  return {
    user: resolve(data, `step_completion/user`),
    errors: resolve(data, `step_completion/errors`, []),
    success: resolve(data, `step_completion/success`),
  };
};

export { markStep, completeStep, removeCompletedStep, markStepParseQuery };
